module.exports = __webpack_public_path__ + "static/media/CSBannerinfo2.8f1d359a.svg";